export default __webpack_public_path__ + "static/media/empty-flow.fe084891.svg";